// FIXME this entire view should be refactored
define('modules/form/switch_view',[
  'backbone',
  'jquery',
  '_',

  './form_item_view',
  'modules/form/convert-form-data',

  'text!./switch_template.html',
], function (Backbone, $, _, FormItemView, convertFormData, template) {
  'use strict';
  var View = FormItemView.extend({
    initialize: function (options) {
      _.extend(this, options);

      FormItemView.prototype.initialize.apply(this, options);
      this.checkboxParts = this.getCheckboxParts();
      this.targetBy = this.model.get('parts')[0].name;
      var that = this;
      _.forEach(this.model.get('parts'), function (part) {
        _.forEach(part.fields, function (field) {
          var values = [];
          if (field.type === 'checkbox') {
            _.forEach(field.options, function (option) {
              if (option.state === 'active') {
                values.push(option.value);
              }
            });
          }
          if (field.type === 'playercapacitycheckbox') {
            _.forEach(field.options, function (option) {
              if (option.playerCapacity) {
                var secondsLeft =
                  option.playerCapacity.max_looplength -
                  option.playerCapacity.current_looplength;
                  option.playerCapacity.seconds_left = Math.max(0, secondsLeft);
              } 
              if (option.state === 'active') {
                values.push(option.value);
              }
            });
          }
          that.dataModel.set(field.name, values);
          if (values.length) {
            that.targetBy = part.name;
          }
        });
      });
      if (!this.model.get('targetBy')) {
        this.model.set('targetBy', this.targetBy);
      }

      this.listenTo(
        this.dataModel,
        'change',
        function (model) {
          this.checkSwitch();
        },
        this
      );

      this.render();
      // Wait for rendering
      setTimeout(function () {
        that.checkSwitch();
      }, 100);
    },

    events: {
      'click .js-switch-target-by': 'switchTargetBy',
      'change input': 'inputChange',
      'click .js-search-icon': 'search',
      'click .js-search-clear-icon': 'clearSearch',
      'keydown .js-search-field-input': 'inputKeydown',
      'keyup .js-search-field-input': 'inputKeyup',
      'click .js-select-all': 'selectAll',
      'click .js-deselect-all': 'deselectAll',
    },

    getCheckboxParts: function () {
      var parts = [];
      _.forEach(this.model.get('parts'), function (part) {
        _.forEach(part.fields, function (field) {
          if (field.type == 'checkbox' || field.type == 'playercapacitycheckbox') {
            parts.push(field.name);
          }
        });
      });
      return parts;
    },

    switchTargetBy: function (e) {
      var targetBy = $(e.currentTarget).data('part');
      $(e.currentTarget).addClass('active');
      this.model.set('targetBy', targetBy);
      this.render();
      this.checkSwitch();
    },

    inputChange: function (e) {
      var target = this.$(e.currentTarget);
      this.dataModel.unset(target.data('parent'), { silent: true });
      var checkboxValue = [];
      checkboxValue = convertFormData(
        this.$('[name="' + e.target.name + '"]').serializeArray()
      );
      this.dataModel.set(checkboxValue);

      _.forEach(this.model.get('parts'), function (part) {
        _.forEach(part.fields, function (field) {
          if (field.name === target.data('parent')) {
            _.forEach(field.options, function (option) {
              if (e.target.value == option.value) {
                if (target.is(':checked')) {
                  option.state = 'active';
                } else {
                  option.state = '';
                }
              }
            });
          }
        });
      });

      // Only the active part should be sent to backend when save form
      var that = this;
      _.forEach(this.checkboxParts, function (part) {
        if (part !== target.data('parent')) {
          that.dataModel.unset(part, { silent: true });
        }
      });

      this.dataModel.trigger('change');
    },

    search: function (e) {
      var selectAllField = document.getElementById('select-all-field');
      if (selectAllField) {
        selectAllField.style.display = 'none';
      }

      var target = this.$(e.currentTarget);
      var searchText = this.$('#search-field').val();
      this.$('#icon-search-target-by').addClass('hide');
      this.$('#icon-clear-target-by').removeClass('hide');
      var that = this;
      _.forEach(this.model.get('parts'), function (part) {
        // We only want the checkboxes that are in the same part as the search field
        if (part.name === target.data('part')) {
          _.forEach(part.fields, function (field) {
            if (field.type == 'checkbox' || field.type == 'playercapacitycheckbox') {
              _.forEach(field.options, function (option) {
                if (
                  !option.label.toLowerCase().includes(searchText.toLowerCase())
                ) {
                  document.getElementById(
                    'checkbox-' + option.label
                  ).style.display = 'none';
                } else {
                  document.getElementById(
                    'checkbox-' + option.label
                  ).style.display = '';
                }
              });
            }
          });
        }
      });
    },

    clearSearch: function (e) {
      var selectAllField = document.getElementById('select-all-field');
      if (selectAllField) {
        selectAllField.style.display = '';
      }

      var allCheckboxes = document.getElementsByClassName('checkbox');
      for (var i = 0; i < allCheckboxes.length; i++) {
        allCheckboxes[i].style.display = '';
      }
      this.$('#icon-search-target-by').removeClass('hide');
      this.$('#icon-clear-target-by').addClass('hide');
      this.$('#search-field').val('');
    },

    inputKeydown: function (e) {
      this.$('#icon-search-target-by').removeClass('hide');
      this.$('#icon-clear-target-by').addClass('hide');
      if (e.keyCode === 13) {
        this.search(e);
        return false;
      }
    },

    inputKeyup: function (e) {
      var searchText = e.currentTarget.value;
      if (searchText === '') {
        if (e.keyCode === 8 || e.keyCode === 46) {
          this.clearSearch();
        }
      }
    },

    checkSwitch: function () {
      var allCheckboxesEmpty = true;
      _.forEach($('.switch-checkbox'), function (inputElement) {
        if (inputElement.checked) {
          allCheckboxesEmpty = false;
          return false;
        }
      });

      var activePart = document.querySelector('.button-menu__button.js-switch-target-by.active');
      if (activePart !== null) {
        $('.js-switch-target-by').removeClass('disabled');
        var that = this;
        var value = that.dataModel.get(activePart.getAttribute('data-part'));
        if (!allCheckboxesEmpty) {
          var otherSwitches = document.querySelectorAll(
            '.js-switch-target-by:not(.active)'
          );
          _.forEach(otherSwitches, function (o) {
            o.classList.add('disabled');
          });
        }
      }
    },

    selectAll: function (e) {
      e.preventDefault();

      _.forEach($('.switch-checkbox'), function (inputElement) {
        inputElement.checked = true;
      });

      var partType = e.currentTarget.getAttribute('data-parent');
      var checkboxValue = [];
      checkboxValue = convertFormData(
        this.$('[data-parent="' + partType + '"]').serializeArray()
      );
      this.dataModel.set(checkboxValue);

      _.forEach(this.model.get('parts'), function (part) {
        _.forEach(part.fields, function (field) {
          if (field.name === partType) {
            _.forEach(field.options, function (option) {
              option.state = 'active';
            });
          }
        });
      });

      this.dataModel.trigger('change');
      this.checkSwitch();
    },

    deselectAll: function (e) {
      e.preventDefault();

      _.forEach($('.switch-checkbox'), function (inputElement) {
        inputElement.checked = false;
      });
      var partType = e.currentTarget.getAttribute('data-parent');
      var checkboxValue = [];
      this.dataModel.set(partType, checkboxValue);
    
      _.forEach(this.model.get('parts'), function (part) {
        _.forEach(part.fields, function (field) {
          if (field.name === partType) {
            _.forEach(field.options, function (option) {
              option.state = '';
            });
          }
        });
      });

      this.dataModel.trigger('change');
      this.checkSwitch();
    },

    template: _.template(template),

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      return this;
    },
  });
  return View;
});

